import { EXPERIMENT_CAJA_PRICE_WIDGET_REMOVAL } from 'src/app/shared/config/features';

type HubbleExperiment = {
  experimentName: string;
  experimentParticipantStatus: string;
};

export type HubbleExperiments = Record<string, HubbleExperiment>;

export type Experiment = {
  experimentNum: number;
  experimentId: string;
};

export type Variant = number | boolean | string;

export type TrackingExperiment = {
  num: number;
  id: string;
  variant: Variant;
};

type TrackingHubbleExperiment = {
  name: string;
  participantStatus: string;
  variant: Variant;
};

export type TrackingHubbleExperiments = Record<
  string,
  TrackingHubbleExperiment
>;

export const hubbleExperiments: HubbleExperiments = {
  [EXPERIMENT_CAJA_PRICE_WIDGET_REMOVAL]: {
    experimentName: 'caja-price-widget-removal',
    experimentParticipantStatus: 'enrolled',
  },
};

export const experiments = [
  {
    experimentId: EXPERIMENT_CAJA_PRICE_WIDGET_REMOVAL,
    experimentNum: 2,
  },
] satisfies Experiment[];
